<template>
  <div class="t-price">
    <template v-if="price > 0">
      <span
        class="price"
        :class="[
          {'span_isdetail': inDetail},
          {'smallCard_price': smallCard}
        ]"
      >
        {{ price | currency}}
      </span>
     
      <i>/{{unit}}</i>
    </template>
    <template v-else>
      <span class="price--ask">
        现询
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: 't-price',
  props: {
    price: {
      type: String,
      default: '3680023.2222'
    },
    inDetail: {
      type: Boolean,
      default: false
    },
    smallCard: {
      type: Boolean,
      default: false
    },
    unit: {
      type: String,
      default: '人'
    }
  },
  filters: {
    currency (v) {
      if (!v) return ''
      let temp = v.toString().split('.')[0]
      return temp.replace(/\d+/, n => { // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, $1 => { // 对整数部分添加分隔符
          return `${$1},`
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .t-price {
    display: inline-block;
    .price,
    .price--ask {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #C04374;
      letter-spacing: 0.15px;
      line-height: 14px;
    }
    .span_isdetail {
      font-family: PingFangSC-Regular;
      font-size: 18px;
      color: #C04374;
      letter-spacing: 0.5px;
      line-height: 18px;
    }
    .smallCard_price {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #C04374;
      letter-spacing: 0.3px;
      line-height: 12px;
    }
    .price:before {
      content: '￥';
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #C04374;
      letter-spacing: 0.3px;
      line-height: 12px;
    }
    .smallCard_price:before {
      content: '￥';
      font-family: PingFangSC-Regular;
      font-size: 10px;
      color: #C04374;
      letter-spacing: 0.15px;
      line-height: 10px;
    }
    .price:after {
      content: '起';
      padding-left: 2px;
      font-family: PingFangSC-Light;
      font-size: 10px;
      color: #898989;
      letter-spacing: 0.15px;
      line-height: 10px;
    }
    i {
      font-family: PingFangSC-Light;
      font-size: 10px;
      color: #898989;
      letter-spacing: 0.15px;
      line-height: 10px;
      font-style: normal;
      margin-left: -3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TPrice.vue